import { render, staticRenderFns } from "./PeopleMap.vue?vue&type=template&id=4bef6a3c&scoped=true&"
import script from "./PeopleMap.vue?vue&type=script&lang=js&"
export * from "./PeopleMap.vue?vue&type=script&lang=js&"
import style0 from "./PeopleMap.vue?vue&type=style&index=0&id=4bef6a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bef6a3c",
  null
  
)

/* custom blocks */
import block0 from "./PeopleMap.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports